/*eslint-disable*/
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";
import ProductCategoryDropdown from 'views/CommonUseComponents/ProductCategoryDropdown.js';
import Datetime from "react-datetime";
import FormControl from "@material-ui/core/FormControl";
import moment from 'moment';
import Dropdown from 'views/CommonUseComponents/Dropdown.js';

// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import NavPills from "components/NavPills/NavPills.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import Danger from "components/Typography/Danger.js"

// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import styles_alert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styles_tableBtn from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import ImageUpload from "components/CustomUpload/ImageUpload.js";

import ICON_BACK from "@material-ui/icons/ArrowBackIos";
import ICON_DONE from "@material-ui/icons/Done";
import ICON_ADD from "@material-ui/icons/Add";

const useStyles = makeStyles(styles);
const useStyles_alert = makeStyles(styles_alert);
const useStyles_tableBtn = makeStyles(styles_tableBtn);

import SweetAlert from "react-bootstrap-sweetalert";

import Loc from "localization";
import fetchAPI from "connectionHandler/FetchAPI.js";



export default function Inventory_in_add(props) {

    const data_targetCollection = "Inventory-In";
      // type validation
  const [isEdit, setIsEdit] = React.useState(false);

  const [data_isPreLoadData, setData_preLoadData] = React.useState(false);

  const [data_id, setData_id] = React.useState("");
  const [data_expenditureID, setData_expenditureID] = React.useState("");
  const [data_name, setData_itemName] = React.useState("");
  const [data_remark, setData_remark] = React.useState("");
  const [data_itemsInPackage, setData_itemsInPackage] = React.useState([]);
  const [data_OrgItemsInPackage, setData_OrgItemsInPackage] = React.useState([]);
  
  const [data_date, setData_date] = React.useState(new Date());
  const [dateState, setdateState] = React.useState("");
  const [data_storeID, setData_storeID] = React.useState("");
  const [data_storeName, setData_storeName] = React.useState("");
  

  const [data_itemsInPackageTableList, setData_itemsInPackageTableList] = React.useState([]);
  

  const [pathToRedirect, setRedirect] = React.useState("");

  const collectionsToLoad = ["Product", "Store"];
  const [data_dataListArray, setData_dataListArray] = React.useState(null);
  const [isPreLoadedData, setIsPreLoadedData] = React.useState(false);
  const [isLoadedEditData, setIsLoadedEditData] = React.useState(false);

//   const [productNameState, setproductNameState] = React.useState("success");

  const [fetchingStatus, setFetchingStatus] = React.useState("");
  const [historyState,setHistoryState] = React.useState(null)
  // alert
  const [alert_save, setSaveAlert] = React.useState(null);
  const [alert_confirm, setConfirmAlert] = React.useState(null);
  const hideAlert = () => {
    setSaveAlert(null);
    setConfirmAlert(null);
  }

  const div_list_empty = () => {
    const theDiv =  <GridItem xs={12} align="center"><Danger>{Loc.list_empty}</Danger></GridItem>
    return theDiv;
  }

  React.useEffect(() => {  
    setHistoryState(props.history.location.state)

    var promise_preLoad = null;

    if (!isPreLoadedData)
    {
        setIsPreLoadedData(true);

        promise_preLoad = do_loadListOfCollection(collectionsToLoad, {"":""}).then(returnList => {
            console.log("returnList: ", returnList);
            setData_dataListArray(returnList);
        })
    }

    // pre load data for edit
    if (data_dataListArray !== null && props.location.state.data !== null && !isLoadedEditData)
    {        
        var dataToEdit = props.location.state.data;
        setIsEdit(true);
        setData_id(dataToEdit.id);
        setData_expenditureID(dataToEdit.expenditureID);
        setData_itemName(dataToEdit.itemName);
        setData_remark(dataToEdit.remark);
        setData_itemsInPackage(dataToEdit.itemsInPackage);
        setData_date(dataToEdit.date);
        setData_storeID(dataToEdit.storeID);

        const orgData = dataToEdit.itemsInPackage.map((item, key) => {
            const copyItem = {
                "id":item.id,
                "type":item.type,
                "qty":item.qty,
                "cost":item.cost,
                "itemName":item.itemName,
            }
            return copyItem;
        })
        setData_OrgItemsInPackage(orgData);

        process_itemsInPackageTableList(dataToEdit.itemsInPackage);
    }
    
    // Specify how to clean up after this effect:
    return function cleanup() {
        promise_preLoad = null;
    };
  }, [data_dataListArray]);

  function do_loadListOfCollection(collectionsList, onHoldList)
  {
      var newList = collectionsList;
      var newOnHoldList = onHoldList;

      const targetCollection = newList[0];
      return new Promise((onDone) => {
          const body = {
              "data_targetCollection":targetCollection
          }
          fetchAPI.do_fetch('post', 'admin/list-all', body)
          .then((res) => {
            newOnHoldList[targetCollection] = res.data.data_list;
            newList.splice(0, 1);

            if (newList.length > 0)
            {
                do_loadListOfCollection(newList, newOnHoldList).then(finalOnHoldList => {
                    onDone(finalOnHoldList);
                })
            }
            else
            {
                onDone(newOnHoldList);
            }
            //   onDone(res.data.data_list);
          }, error => {
              console.log("failed: ", error);
              onDone(null);
          })
      });
  }

  function process_itemTableList(targetData)
  {
    const newData = targetData.filter(v => v.isDeleted != true).map((prop, key) => {
        const product_id = prop.id;
        const itemName = prop.itemName;
        const price = prop.price;
        
        return {
          no: key+1,
          id: key,
          product_id: product_id,
          itemName: (
          <span>
            {/* <img src={prop.imageUrl} alt="..." /> */}
            {itemName}
          </span>
          ),
          product_id: product_id,
          price: "$ " + price,
          actions: (
            // we've added some custom button actions
            <div className="actions-right">
              {/* use this button to add a edit kind of action */}
                <Button color="success" 
                simple 
                className={classes_tableBtn.actionButton}
                onClick={() => {
                    do_addItemIntoPackage(prop, "item");
                }}>
                    <ICON_ADD className={classes_tableBtn.icon}/>
                </Button>
            </div>
          )
        };
      })
  
      return newData;
    //   setData_itemTableList(newData);
  }

  function process_couponTableList(targetData)
  {
    const newData = targetData.filter(v => v.isDeleted != true).map((prop, key) => {
        const product_id = prop.id;
        const itemName = prop.itemName;
        const price = prop.price;
        
        return {
          no: key+1,
          id: key,
          product_id: product_id,
          itemName: (
          <span>
            {/* <img src={prop.imageUrl} alt="..." /> */}
            {itemName}
          </span>
          ),
          product_id: product_id,
          price: "$ " + price,
          actions: (
            // we've added some custom button actions
            <div className="actions-right">
              {/* use this button to add a edit kind of action */}
                <Button color="success" 
                simple 
                className={classes_tableBtn.actionButton}
                onClick={() => {
                    do_addItemIntoPackage(product_id, "coupon");
                }}>
                    <ICON_ADD className={classes_tableBtn.icon}/>
                </Button>
            </div>
          )
        };
      })
  
      return newData;
    //   setData_couponTableList(newData);
  }

  function do_addItemIntoPackage(targetItem, targetType)
  {
    var newItemList = data_itemsInPackage;
    const targetID = targetItem.id;
    const itemName = targetItem.itemName;

    // items in package logic
    var itemIndexKey = -1;
    newItemList.map((item, key) => {
        if (item.id === targetID)
        {
            itemIndexKey = key;
        }
    });
    if (itemIndexKey == -1)
    {
        const newItem = {
            id: targetID,
            qty: 1.0,
            type: targetType,
            cost: 0,
            itemName: itemName,
        }
        newItemList.push(newItem);
    }
    else
    {
        var newQty = parseFloat(newItemList[itemIndexKey].qty);
        newQty += 1.0;
        newItemList[itemIndexKey].qty = newQty;
    }
    setData_itemsInPackage(newItemList);
    process_itemsInPackageTableList(newItemList);
  }

  const validCheck = () => {
    var result = true;
    if (dateState === "error")
    {
        result = false;
    }
    return result;
  }

  const backClicked = () => {
    setRedirect("/admin/inventory-in-list");
  }

  const doneClicked =() => {
    setFetchingStatus("fetching");
    if (validCheck())
    {
        const expenditureBody = get_expenditureBody();
        const balanceChangeList = get_balanceChangeList();

        api_add_inventory(expenditureBody, balanceChangeList).then((isAddInventory) => {
            if (isAddInventory)
            {
                setFetchingStatus("");
                showAlert(true, Loc.success, Loc.data_save_success);
            }
        });
    }
    else
    {
        // setproductNameState("error");
        setFetchingStatus("");
        showAlert(false, Loc.failed, Loc.data_save_failed);
    }
  }

  function api_add_inventory(expenditureBody, balanceChangeList)
  {
    return new Promise((onDone) => {

        const expenditureID = expenditureBody.id;
        const expenditureContent = expenditureBody.content;

        const idToPass = isEdit ? data_id : null;
        const body = {
            "id":idToPass,
            "expenditureID":expenditureID,
            "expenditureContent":expenditureContent,
            "balanceChangeList":balanceChangeList,
            "content":{
                "itemName":data_name,
                "remark":data_remark,
                "itemsInPackage":data_itemsInPackage,
                "date":new Date(data_date).getTime(),
                "storeID":data_storeID,
                "storeName":data_storeName,
            }
        }
        fetchAPI.do_fetch('post', 'admin/create-inventory-in', body)
        .then((res) => {
            onDone(true);
        }, error => {
            console.log("failed: ", error);
            setFetchingStatus("");
            onDone(false);
        })
    });
  }
  function get_expenditureBody()
  {
    const idToPass = isEdit ? data_expenditureID : null;
    var totalAmount = 0
    data_itemsInPackage.map((item, key) => {
        totalAmount += item.cost;            
    })
    const body = {
        "id":idToPass,
        "content":{
            "itemName":Loc.purchases_expenditure,
            "amount":totalAmount,
            "remark":"",
            "date":new Date(data_date).getTime(),
            "storeID":data_storeID,
            "type":"inventory-in",
        }
    }
    return body;
  }

  function get_balanceChangeList()
  {
    var newChangeList = [];
    data_itemsInPackage.map((item, key) => {
        const newChange = {
            id:item.id,
            type: item.type,
            change_val: item.qty,
            itemName: item.itemName,
        }
        newChangeList.push(newChange);
    })

    if (isEdit)
    {
        data_OrgItemsInPackage.map((oldItem, key) => {
            var isExist = false;
            var isNoChange = false;
            const targetItemID = oldItem.id;
            const oldValue = oldItem.qty;
            var newValue = 0;

            // check if exist
            newChangeList.map((newItem, keyKey) => {
                if (oldItem.id == newItem.id)
                {
                    isExist = true;
                    if (oldValue == newItem.change_val)
                    {
                        isNoChange = true;
                        newChangeList.splice(keyKey, 1);
                        console.log("is no change");
                    }
                    else
                    {
                        newValue = newItem.change_val;
                    }
                }
            });

            if (!isNoChange)
            {
                const changeVal = (isExist) ? (newValue - oldValue) : (0-oldValue);

                console.log("changeVal: ", changeVal);
                console.log("newValue: ", newValue);
                console.log("oldValue: ", oldValue);
                const newChange = {
                    id:targetItemID,
                    type: oldItem.type,
                    change_val: changeVal,
                    itemName: oldItem.itemName,
                }
                newChangeList[key] = newChange;
            }
        })
    }
    return newChangeList;
  }

  function showAlert(issuccess, title, content){
    setSaveAlert(
      <SweetAlert
        error={!issuccess}
        success={issuccess}
        style={{ display: "block", marginTop: "-100px" }}
        closeOnClickOutside={false}
        title={title}
        onConfirm={() => {
            if (issuccess)
            {
                // hideAlert()
                setRedirect("/admin/inventory-in-list");
            }
            else
            {
                hideAlert()
            }
        }}
        confirmBtnCssClass={classes_alert.button + " " + classes_alert.success}
        cancelBtnCssClass={classes_alert.button + " " + classes_alert.info}
        onCancel={() => {
            if (issuccess)
            {
                setData_itemName("");
                setData_remark("");
                setData_itemsInPackage([]);
                process_itemsInPackageTableList([]);
                setData_date(new Date());
                // window.location.reload(false);
                hideAlert()
            }
            else
            {
                hideAlert()
            }
            
        }}
        confirmBtnText={issuccess ? Loc.done : Loc.confirm}
        cancelBtnText={Loc.continue}
        btnSize="lg"
        showCancel={issuccess && !isEdit}
      >
        {content}
      </SweetAlert>
    );
  }
  function showConfirmRemoveFromPackageAlert(itemKey, itemsInPackage)
  {
    setConfirmAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        closeOnClickOutside={false}
        title={Loc.confirm_delete_title}
        onConfirm={() => {
            var newItemsInPackage = itemsInPackage;
            newItemsInPackage.splice(itemKey, 1);
            setData_itemsInPackage(newItemsInPackage);
            process_itemsInPackageTableList(newItemsInPackage);
            hideAlert();
        }}
        confirmBtnCssClass={classes_alert.button + " " + classes_alert.success}
        cancelBtnCssClass={classes_alert.button + " " + classes_alert.info}
        onCancel={() => {
            hideAlert();
        }}
        confirmBtnText={Loc.confirm}
        cancelBtnText={Loc.cancel}
        btnSize="lg"
        showCancel
      >
        {Loc.are_you_sure}
      </SweetAlert>
    );
  }

  const check_redirect = () => {
      if (pathToRedirect != "")
      {
          return (<Redirect to={{
            pathname: pathToRedirect,
            state: historyState.config,
          }} 
/>);
      }
      else
      {
          return null;
      }
  }

  function process_itemsInPackageTableList(rawData_itemsInPackage) {
    const list = rawData_itemsInPackage.map((prop, key_itemInPackage) => {

        const itemID = prop.id;
        var itemName = prop.itemName;
        const qty = prop.qty;
        var isDeleted = false;

        return [
            (
                isDeleted ? <Danger>{itemName}</Danger> : itemName
            ),
            (<CustomInput
                labelText={Loc.quantity_short}
                id="quantity_short"
                formControlProps={{
                fullWidth: true
                }}
                inputProps={{
                    value: rawData_itemsInPackage[key_itemInPackage].qty,
                    onChange: event => {
                        var newItemsInPackage = rawData_itemsInPackage;
                        const newQty = parseFloat(event.target.value);

                        if (newQty <= 0)
                        {
                            showConfirmRemoveFromPackageAlert(key_itemInPackage);
                        }
                        else
                        {
                            newItemsInPackage[key_itemInPackage].qty = newQty;
                        }
                        setData_itemsInPackage(newItemsInPackage);
                        process_itemsInPackageTableList(newItemsInPackage);
                    },
                    type: "number",
                }}
            />),
            (<CustomInput
                labelText={Loc.product_cost}
                id="product_cost"
                formControlProps={{
                fullWidth: true
                }}
                inputProps={{
                    value: rawData_itemsInPackage[key_itemInPackage].cost,
                    onChange: event => {
                        var newItemsInPackage = rawData_itemsInPackage;
                        var newCost = parseFloat(event.target.value);

                        if (newCost <= 0)
                        {
                            newCost = 0;
                        }

                        newItemsInPackage[key_itemInPackage].cost = newCost;
                        
                        setData_itemsInPackage(newItemsInPackage);
                        process_itemsInPackageTableList(newItemsInPackage);
                    },
                    type: "number",
                }}
            />),
            (<Button color="danger" simple className={classes_tableBtn.actionButton} onClick={(e) => {
                showConfirmRemoveFromPackageAlert(key_itemInPackage, rawData_itemsInPackage);
            }}>
                <Close className={classes_tableBtn.icon}/>
            </Button>)
        ]
    });

    setData_itemsInPackageTableList(list);
  }
  
    const classes = useStyles();
    const classes_alert = useStyles_alert();
    const classes_tableBtn = useStyles_tableBtn();

    return (
    <div>
        {check_redirect()}
        {alert_save}
        {alert_confirm}
        <GridContainer>
        <GridItem xs={6}>
            <Card>
            <CardHeader color="rose" text>
                <CardText color="rose">
                    <h4 className={classes.cardTitle}>{Loc.inventory_in_add}</h4>
                </CardText>
            </CardHeader>
            <CardBody>
                <GridContainer>

                <GridItem xs={12} align="center">
                    <Dropdown
                        currentID={data_storeID}
                        listData={data_dataListArray === null ? [] : data_dataListArray["Store"]}
                        defaultSelectionString={Loc.store_default}
                        didSelectItem={(selectedItem) => {
                            if (selectedItem === null)
                            {
                                setData_storeID("");
                                setData_storeName("");
                            }
                            else
                            {
                                const selectedID = selectedItem.id;
                                const storeName = selectedItem.itemName;
                                setData_storeName(storeName);
                                setData_storeID(selectedID);
                            }
                            
                        }}
                    />
                    {/* <StoreDropdown
                        storeID={data_storeID}
                        didSelectedStore={(selectedID) => {
                            setData_storeID(selectedID);
                        }}
                    /> */}
                </GridItem>

                <GridItem xs={12}>
                    <FormControl fullWidth>
                        <Datetime
                            timeFormat={false}
                            defaultValue={data_date}
                            value={data_date == null ? moment(new Date()): moment(data_date)}
                            inputProps={{ 
                                placeholder: Loc.inventory_in_date,
                            }}
                            onChange={m => {
                                if (moment.isMoment(m))
                                {
                                    setdateState("success");
                                    setData_date(m.toDate());
                                }
                                else{
                                    setdateState("error");
                                }
                            }}
                        />
                    </FormControl>
                </GridItem> 

                <GridItem xs={12}>
                    <CustomInput
                        // success={requiredState === "success"}
                        // error={productNameState === "error"}
                        labelText={Loc.inventory_in_description}
                        id="inventory_in_description"
                        formControlProps={{
                        fullWidth: true
                        }}
                        inputProps={{
                            value: data_name,
                            onChange: event => {
                                // setproductNameState("success");
                                setData_itemName(event.target.value);
                            },
                            type: "text",
                        }}
                    />
                </GridItem> 

                

                <GridItem xs={12}>
                    <CustomInput
                        labelText={Loc.remark}
                        id="remark"
                        formControlProps={{
                        fullWidth: true
                        }}
                        inputProps={{
                            value: data_remark,
                            onChange: event => {
                                setData_remark(event.target.value);
                            },
                            type: "text",
                        }}
                    />
                </GridItem> 


                <GridItem xs={12}>
                    <Card>
                    <CardHeader color="info" text>
                        <CardText color="info">
                            <h5 className={classes.cardTitle}>{Loc.inventory_in_list}</h5>
                        </CardText>
                    </CardHeader>
                    <CardBody>
                    {
                        data_itemsInPackage.length == 0 ? 
                        div_list_empty()
                        : 
                        <Table
                        tableHead={[
                            // "#",
                            Loc.product,
                            Loc.quantity_short,
                            Loc.price_short,
                            Loc.remove
                        ]}
                        tableData={data_itemsInPackageTableList}
                        customCellClasses={[classes.center, classes.right, classes.right]}
                        customClassesForCells={[0, 4, 5]}
                        customHeadCellClasses={[
                            classes.center,
                            classes.right,
                            classes.right
                        ]}
                        customHeadClassesForCells={[0, 4, 5]}
                    />
                    }
                    </CardBody>
                    </Card>
                </GridItem>
                </GridContainer>
            </CardBody>
            <CardFooter className={classes.justifyContentCenter}>
                <GridContainer spacing={2}
                direction="row"
                justify="center"
                alignItems="center">
                    <GridItem xs={6} align="center">
                        <Button onClick={backClicked}>
                        <ICON_BACK />
                        {Loc.back}
                        </Button>
                    </GridItem>

                    <GridItem xs={6} align="center">
                        <Button color="rose" onClick={doneClicked} disabled={fetchingStatus==="fetching" ? true : false}>
                        <ICON_DONE />
                        {isEdit ? Loc.save : Loc.create}
                        </Button>
                    </GridItem>
                </GridContainer>
            </CardFooter>
            </Card>
        </GridItem>

        <GridItem xs={6}>
            <Card>
            <CardHeader color="rose" text>
                <CardText color="rose">
                    <h4 className={classes.cardTitle}>{Loc.product_list}</h4>
                </CardText>
            </CardHeader>
            <CardBody>
                
                {/* <hr/> */}
                <NavPills
                color="info"
                tabs={[
                  {
                    tabButton: Loc.product,
                    tabContent: (
                        (data_dataListArray == null || data_dataListArray["Product"] == null || process_itemTableList(data_dataListArray["Product"]).length == 0) ? 
                        div_list_empty()
                        :
                        <ReactTable
                            columns={[
                                {
                                Header: Loc.product_name,
                                accessor: "itemName"
                                },
                                {
                                Header: Loc.product_price,
                                accessor: "price"
                                },
                                {
                                Header: Loc.add,
                                accessor: "actions"
                                }
                            ]}
                            data={data_dataListArray == null ? [] : process_itemTableList(data_dataListArray["Product"])}
                        />
                    )
                  },
                ]}
              />
            </CardBody>
            </Card>
        </GridItem>
        </GridContainer>
    </div>
  );
}